import { useHistory } from 'react-router-dom';
import { Button, useMobile } from '@octano/global-ui';
import { useTranslation } from 'react-i18next';
import { SectionDetailBox } from '../../../components/sectionDetailBox/SectionDetailBox';
import { StartSurveyData } from '../types';

type Props = {
  courseInfo: StartSurveyData['sectionDetail'];
};

export function CourseInfo({ courseInfo }: Props) {
  const history = useHistory();
  const isMobile = useMobile();
  const { t } = useTranslation();

  return (
    <div
      className="d-flex flex-wrap justify-content-between mb-5"
      style={{ gap: isMobile ? 12 : 0 }}
    >
      <Button
        text={t(`common.btnBack`)}
        icon="back"
        size="sm"
        outlined
        rounded
        style={{ width: 'fit-content', height: 'fit-content' }}
        onClick={() => history.push('/student-management/courses')}
      />

      <SectionDetailBox
        course={courseInfo.course}
        section={courseInfo.section}
        shortening={courseInfo.shortening}
      />
    </div>
  );
}
